import LegalPage from "@/pages/LegalPage";

const SECTIONS = [
  {
    h: "Our Commitment",
    p: [
      "Trainova is committed to making fitness accessible to everyone. We strive to ensure our website and application are usable by as many people as possible, including those who rely on assistive technologies.",
      "We aim to conform to the Web Content Accessibility Guidelines (WCAG) 2.1 Level AA as a measurable standard for our digital experiences.",
    ],
  },
  {
    h: "What We Do",
    p: ["To support an inclusive experience, we work to:"],
    list: [
      "Maintain strong color contrast between text and backgrounds for readability.",
      "Provide descriptive alternative text for meaningful images.",
      "Ensure interactive elements are reachable and operable via keyboard.",
      "Use clear, semantic structure and labels on forms and controls.",
      "Respect reduced-motion preferences by minimizing animation for users who request it.",
    ],
  },
  {
    h: "Reduced Motion",
    p: [
      "Trainova features rich, scroll-based animations. If you have enabled a \"reduce motion\" setting in your operating system or browser, we automatically limit non-essential motion to keep the experience comfortable.",
    ],
  },
  {
    h: "Ongoing Improvement",
    p: [
      "Accessibility is an ongoing effort. We regularly review our site and app and make improvements as standards evolve and as we receive feedback from our community.",
    ],
  },
  {
    h: "Feedback & Support",
    p: [
      "If you encounter any accessibility barrier on Trainova, or need content provided in an alternative format, please let us know. We take all feedback seriously and will work to address issues promptly.",
      "Contact us at support@trainovaapp.com with the details, and we'll do our best to help.",
    ],
  },
];

export default function Accessibility() {
  return (
    <LegalPage
      testid="accessibility-page"
      eyebrow="FITNESS FOR EVERYONE"
      title="Accessibility"
      accent="statement"
      subtitle="Our commitment to an inclusive, usable experience for every member."
      updated="June 2026"
      sections={SECTIONS}
    />
  );
}
